export const GET_DRIVE_TIME_AVG = 'GET_DRIVE_TIME_AVG';
export const GET_DRIVE_TIME_PERCENT = 'GET_DRIVE_TIME_PERCENT';
export const GET_DRIVE_TIME_STATUS = 'GET_DRIVE_TIME_STATUS';
